import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { useParams, useNavigate } from 'react-router-dom';

const ImportedLeadsPage = () => {
  const { campaignId, fileId } = useParams();
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);
  const [file, setFile] = useState(null);
  const [agents, setAgents] = useState({});
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    loadData();
    loadAgents();
  }, [fileId]);

  const loadAgents = async () => {
    const { data } = await supabase
      .from('profiles')
      .select('id, email, full_name');
    
    const map = {};
    (data || []).forEach(a => map[a.id] = a);
    setAgents(map);
  };

  const loadData = async () => {
    setLoading(true);
    
    const { data: fileData } = await supabase
      .from('campaign_files')
      .select('file_name')
      .eq('id', fileId)
      .single();
    setFile(fileData);

    const { data: leadsData } = await supabase
      .from('imported_leads')
      .select('*')
      .eq('file_id', fileId)
      .order('row_number');

    setLeads(leadsData || []);
    setLoading(false);
  };

  const handleConvertToLead = async (importedLead) => {
    try {
      setProcessing(true);

      const { data: newLead, error } = await supabase
        .from('leads')
        .insert({
          ...importedLead.data,
          assigned_to: importedLead.agent_id,
          status: 'nouveau',
          source: 'import',
          imported_from: fileId,
          created_at: new Date()
        })
        .select()
        .single();

      if (error) throw error;

      await supabase
        .from('imported_leads')
        .update({
          status: 'converted',
          lead_id: newLead.id
        })
        .eq('id', importedLead.id);

      loadData();
    } catch (error) {
      alert('Erreur: ' + error.message);
    } finally {
      setProcessing(false);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        Chargement...
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f3f4f6', padding: '2rem' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <button
          onClick={() => navigate(`/campaigns/${campaignId}/files`)}
          style={{ marginBottom: '1rem', color: '#2563eb', background: 'none', border: 'none', cursor: 'pointer' }}
        >
          ← Retour aux fichiers
        </button>

        <h1 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '2rem' }}>
          Leads importés - {file?.file_name}
        </h1>

        <div style={{ backgroundColor: 'white', borderRadius: '0.5rem', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ backgroundColor: '#f9fafb' }}>
              <tr>
                <th style={{ padding: '0.75rem 1rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: '600', color: '#4b5563' }}>#</th>
                <th style={{ padding: '0.75rem 1rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: '600', color: '#4b5563' }}>Données</th>
                <th style={{ padding: '0.75rem 1rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: '600', color: '#4b5563' }}>Agent</th>
                <th style={{ padding: '0.75rem 1rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: '600', color: '#4b5563' }}>Statut</th>
                <th style={{ padding: '0.75rem 1rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: '600', color: '#4b5563' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {leads.map(lead => {
                const agent = agents[lead.agent_id];
                return (
                  <tr key={lead.id} style={{ borderTop: '1px solid #e5e7eb' }}>
                    <td style={{ padding: '1rem' }}>{lead.row_number}</td>
                    <td style={{ padding: '1rem' }}>
                      <pre style={{ margin: 0, fontSize: '0.75rem', maxWidth: '400px', overflow: 'auto' }}>
                        {JSON.stringify(lead.data, null, 2)}
                      </pre>
                    </td>
                    <td style={{ padding: '1rem' }}>
                      <span style={{
                        display: 'inline-block',
                        padding: '0.25rem 0.5rem',
                        backgroundColor: '#dbeafe',
                        color: '#1e40af',
                        borderRadius: '0.25rem',
                        fontSize: '0.75rem'
                      }}>
                        {agent?.full_name || agent?.email || 'Inconnu'}
                      </span>
                    </td>
                    <td style={{ padding: '1rem' }}>
                      <span style={{
                        display: 'inline-block',
                        padding: '0.25rem 0.75rem',
                        borderRadius: '9999px',
                        fontSize: '0.75rem',
                        backgroundColor: lead.status === 'pending' ? '#fff3cd' : '#dcfce7',
                        color: lead.status === 'pending' ? '#856404' : '#166534'
                      }}>
                        {lead.status === 'pending' ? 'En attente' : 'Converti'}
                      </span>
                    </td>
                    <td style={{ padding: '1rem' }}>
                      {lead.status === 'pending' && (
                        <button
                          onClick={() => handleConvertToLead(lead)}
                          disabled={processing}
                          style={{
                            backgroundColor: '#059669',
                            color: 'white',
                            border: 'none',
                            padding: '0.25rem 0.75rem',
                            borderRadius: '0.25rem',
                            fontSize: '0.75rem',
                            cursor: processing ? 'not-allowed' : 'pointer',
                            opacity: processing ? 0.5 : 1
                          }}
                        >
                          Convertir
                        </button>
                      )}
                      {lead.lead_id && (
                        <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                          ✓ Lead créé
                        </span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ImportedLeadsPage;
